// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Circle_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25Zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25Z',
  viewBox: '0 0 24 24',
  glyph: 'Circle_Stroke2_Corner0_Rounded',
})

export const CircleAndSquare_Stroke1_Corner0_Rounded_Filled =
  createSinglePathSVG({
    path: 'M10.462 17.013A.75.75 0 0 1 9.75 18h-7.5a.75.75 0 0 1-.712-.987l3.75-11.25a.75.75 0 0 1 1.424 0ZM19.5 7.125A4.875 4.875 0 1 0 14.625 12 4.88 4.88 0 0 0 19.5 7.125ZM21 13.5h-8.25a.75.75 0 0 0-.75.75v5.25a.75.75 0 0 0 .75.75H21a.75.75 0 0 0 .75-.75v-5.25a.75.75 0 0 0-.75-.75Z',
    viewBox: '0 0 24 24',
    glyph: 'CircleAndSquare_Stroke1_Corner0_Rounded_Filled',
  })

export const CircleBanSign_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25ZM20.25 12a8.2 8.2 0 0 1-1.913 5.276L6.724 5.663A8.25 8.25 0 0 1 20.25 12Zm-16.5 0a8.2 8.2 0 0 1 1.913-5.276l11.613 11.613A8.25 8.25 0 0 1 3.75 12Z',
  viewBox: '0 0 24 24',
  glyph: 'CircleBanSign_Stroke2_Corner0_Rounded',
})

export const CircleCheck_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M16.28 9.22a.75.75 0 0 1 0 1.06l-5.25 5.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 1.06-1.06l1.72 1.72 4.72-4.72a.75.75 0 0 1 1.06 0ZM21.75 12A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12Zm-1.5 0A8.25 8.25 0 1 0 12 20.25 8.26 8.26 0 0 0 20.25 12Z',
  viewBox: '0 0 24 24',
  glyph: 'CircleCheck_Stroke2_Corner0_Rounded',
})

export const CircleInfo_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25Zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25Zm1.5-3.75a.75.75 0 0 1-.75.75 1.5 1.5 0 0 1-1.5-1.5V12a.75.75 0 0 1 0-1.5 1.5 1.5 0 0 1 1.5 1.5v3.75a.75.75 0 0 1 .75.75Zm-3-8.625A1.125 1.125 0 1 1 11.625 9 1.125 1.125 0 0 1 10.5 7.875Z',
  viewBox: '0 0 24 24',
  glyph: 'CircleInfo_Stroke2_Corner0_Rounded',
})

export const CirclePlus_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25Zm0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25ZM16.5 12a.75.75 0 0 1-.75.75h-3v3a.75.75 0 0 1-1.5 0v-3h-3a.75.75 0 0 1 0-1.5h3v-3a.75.75 0 0 1 1.5 0v3h3a.75.75 0 0 1 .75.75Z',
  viewBox: '0 0 24 24',
  glyph: 'CirclePlus_Stroke2_Corner0_Rounded',
})

export const CircleQuestion_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M13.125 16.875A1.125 1.125 0 1 1 12 15.75a1.125 1.125 0 0 1 1.125 1.125ZM12 6.75c-2.068 0-3.75 1.514-3.75 3.375v.375a.75.75 0 0 0 1.5 0v-.375c0-1.031 1.01-1.875 2.25-1.875s2.25.844 2.25 1.875S13.24 12 12 12a.75.75 0 0 0-.75.75v.75a.75.75 0 0 0 1.5 0v-.067c1.71-.315 3-1.679 3-3.308 0-1.86-1.682-3.375-3.75-3.375ZM21.75 12A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12Zm-1.5 0A8.25 8.25 0 1 0 12 20.25 8.26 8.26 0 0 0 20.25 12Z',
  viewBox: '0 0 24 24',
  glyph: 'CircleQuestion_Stroke2_Corner2_Rounded',
})

export const CircleX_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M15.53 9.53 13.06 12l2.47 2.47a.75.75 0 0 1-1.06 1.06L12 13.06l-2.47 2.47a.75.75 0 0 1-1.06-1.06L10.94 12 8.47 9.53a.75.75 0 0 1 1.06-1.06L12 10.94l2.47-2.47a.75.75 0 0 1 1.06 1.06ZM21.75 12A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12Zm-1.5 0A8.25 8.25 0 1 0 12 20.25 8.26 8.26 0 0 0 20.25 12Z',
  viewBox: '0 0 24 24',
  glyph: 'CircleX_Stroke2_Corner0_Rounded',
})
